import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";

/**
 * @fileOverview 封装返回码统计
 */

/* @include "live.define.js" */
import cookie from './cookie';
/**
 * 返回码统计上报
 *
 * @type {Object}
 * @namespace Live.retCode
 */

var retCode = {
  snid: 0,

  /**
   * 返回码上报类型枚举
   *
   * @type {Object}
   */
  TYPE: {
    /**
     * 成功
     *
     * @type Number
     * @default 1
     */
    SUC: 1,

    /**
     * 失败
     *
     * @type Number
     * @default 2
     */
    ERR: 2,

    /**
     * 3逻辑失败
     *
     * @type Number
     * @default 2
     */
    LOGIC_ERR: 3
  },

  /**
   * 配置项
   *
   * @type
   */
  config: {
    /**
     * 请求CGI的url
     *
     * @type String
     * @default http://isdspeed.qq.com/cgi-bin/v.cgi
     */
    cgi: 'https://c.isdspeed.qq.com/code.cgi',

    /**
     * 采样率，100表示1%,1000表示0.1%...
     *
     * @type Number
     * @default 1000
     */
    sampling: 1
  },

  /**
   * 共用的返回码
   *
   * @type
   */
  commCode: {
    error: -1
  },

  /**
   * 上报数据
   *
   * @param {Number}
   *          rettype 返回结果类型1表示成功，2表示失败
   * @param {Number}
   *          delay 延迟时间
   * @param {Number}
   *          errcode 错误码
   */
  report: function report(domain, cgi, rettype, delay, errcode) {
    if (isNaN(rettype) || rettype < 1) return;
    if (typeof delay === 'undefined') return;
    var url = this.config.cgi;
    errcode = errcode || '0';
    url += "?domain=".concat(domain.toString(), "&cgi=").concat(cgi.toString(), "&type=").concat(rettype, "&rate=").concat(retCode.config.sampling, "&time=").concat(delay, "&code=").concat(errcode.toString(), "&uin=").concat(cookie.get('uin') || cookie.get('luin'));
    var imgSend = new Image();
    imgSend.src = url;
  }
};
/**
 * @class Live.retCode
 * @description 返回码监控对象
 */

function RetCode(domain, cgi) {
  /**
   * Cgi所属域名（域名信息需要准确，用于cgi名自动归属业务）
   *
   * @type String
   */
  this.domain = domain;
  /**
   * Cgi名称(如果域名下有同名cgi，请携带路径名区分，不需要带域名了)
   *
   * @type String
   */

  this.cgi = cgi;
  /**
   * 计时器
   *
   * @ignore
   */

  this.timer = {
    begin: new Date().valueOf(),
    end: 0
  };
  /**
   * 当前对象ID
   */

  this.SNID = retCode.snid;
  /**
   * 是否已经上报
   */

  this.isReported = false;
  retCode.snid++;
}

RetCode.TYPE = retCode.TYPE;
RetCode.prototype = {
  /**
   * 开始上报统计
   */
  begin: function begin() {
    this.timer.begin = new Date().valueOf();
  },

  /**
   * 上报结束
   */
  end: function end() {
    this.timer.end = this.timer.end || new Date().valueOf();
  },

  /**
   * 上报
   *
   * @param {Number}
   *          rettype 上报类别，成功是1，失败是2
   * @param {Number}
   *          retcode 返回码
   */
  // reprot : function(rettype, retcode) {
  //    this.report(rettype, retcode);
  // },
  report: function report(rettype, retcode) {
    if (this.isReported) return;
    this.end();
    var delay = this.timer.end - this.timer.begin;
    retCode.report(this.domain, this.cgi, rettype, delay, retcode);
    this.isReported = true;
  },

  /**
   * 上报成功
   */
  reportSuc: function reportSuc() {
    this.report(retCode.TYPE.SUC);
  },

  /**
   * 上报错误
   *
   * @param {Number}
   *          errcode 错误码
   */
  reportErr: function reportErr(errcode) {
    errcode = errcode || retCode.commCode.error;
    this.report(retCode.TYPE.ERR, errcode);
  },

  /**
   * 上报错误
   *
   * @param {Number}
   *          errcode 错误码
   */
  reportLogicErr: function reportLogicErr(errcode) {
    errcode = errcode || retCode.commCode.error;
    this.report(retCode.TYPE.LOGIC_ERR, errcode);
  }
};
export default RetCode;